import { DeviceCategory } from 'components/newPlan/constants';
import * as Styles from './styles';

interface IProps {
    planName: string;
    premium: number;
    deviceName: string;
    serialNumber: string;
    paidBy: string;
    customerMobileNumber: string;
    paidOn: string;
    deviceType: string;
}

function TransactionDetailsCard({
    planName,
    premium,
    deviceName,
    serialNumber,
    paidBy,
    customerMobileNumber,
    paidOn,
    deviceType,
}: IProps) {
    const getLabel = () => {
        if (
            deviceType === DeviceCategory.MOBILE ||
            deviceType === DeviceCategory.TABLET
        ) {
            return 'IMEI';
        }
        return 'Serial number';
    };

    return (
        <Styles.Wrapper>
            <Styles.PlanDetailsFlex>
                <Styles.PlanName>{planName}</Styles.PlanName>
                <Styles.Premium>₹{premium}</Styles.Premium>
            </Styles.PlanDetailsFlex>
            <Styles.DeviceName>{deviceName}</Styles.DeviceName>
            <Styles.IMEI>
                {getLabel()}: {serialNumber}
            </Styles.IMEI>
            <Styles.Hr />
            <Styles.PaidBy>Paid by {paidBy}</Styles.PaidBy>
            <Styles.Label>Customer mobile number</Styles.Label>
            <Styles.Value>{customerMobileNumber}</Styles.Value>
            <Styles.Label>Paid On</Styles.Label>
            <Styles.Value>{paidOn}</Styles.Value>
        </Styles.Wrapper>
    );
}

export default TransactionDetailsCard;
